import React from "react";

import HeroBottom from "./HeroBottom";

import { Wrapper, Container } from "./style";

const HeroSection = ({
  data = {},
  downloadBanner,
  width,
  heroBannerRef,
}: any) => {
  return (
    <Wrapper>
      <Container>
        <HeroBottom data={data} width={width} />
      </Container>
    </Wrapper>
  );
};

export default HeroSection;
